import styled, { css } from 'styled-components'

import { Option } from 'components/Option'

import { Color } from 'root-constants'

export const StyledSelectFamilySize = {
  Wrapper: styled.div`
    max-width: 375px;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.p`
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 24px;
  `,
  QuizLabel: styled.p`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    color: ${Color.GOLD_BASE};

    margin-bottom: 24px;
  `,
  Question: styled.p`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 24px;
  `,
  Options: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  Option: styled(Option)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    min-height: 60px;

    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: ${Color.INK_DARKER};

    background-color: ${Color.WHITE};
    border-radius: 24px;
    transition:
      background-color 200ms ease-out,
      box-shadow 200ms ease-out;

    padding: 4px 16px 4px 25px;

    ${({ checked }) =>
      checked &&
      css`
        background-color: ${Color.GOLD_LIGHTEST};
        box-shadow: 0 0 0 1.5px ${Color.GOLD_LIGHT};
      `}
  `,
  ArrowBadge: styled.span<{ $isActive: boolean }>`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;

    background-color: ${({ $isActive }) =>
      $isActive ? Color.WHITE : Color.SKY};
    border-radius: 50%;
    transition: background-color 200ms ease-out;
  `,
  Terms: styled.div`
    width: 100%;

    padding-top: 32px;
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
}
